import router from './router'
import store from './store'
//   import { Message } from 'element-ui'
import NProgress from 'nprogress' //  progress bar
import 'nprogress/nprogress.css' //  progress bar style
//   import { getToken } from '@/utils/auth' //  get token from cookie
//   import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) //  NProgress Configuration

//   const whiteList = ['/login'] //  no redirect whitelist

const LOGIN_PAGE_NAME = 'Login'

router.beforeEach((to, from, next) => {
  const token = store.state.isLogin
  NProgress.start()
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    //  未登录且要跳转的页面不是登录页
    //  console.log('未登录且要跳转的页面不是登录页', '000000000000000000000')
    next({
      name: LOGIN_PAGE_NAME
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    //  未登陆且要跳转的页面是登录页
    //  console.log('未登陆且要跳转的页面是登录页', '11111111111111111111')
    next()
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    //  已登录且要跳转的页面是登录页
    //  console.log('已登录且要跳转的页面是登录页', '22222222222222222')
    next({
      name: LOGIN_PAGE_NAME
    })
  } else {
    //  console.log('其他', '33333333333333333')
    next()
  }
})
//   router.beforeEach(async (to, from, next) => {
//     //  start progress bar
//     NProgress.start()

//     //  set page title
//     document.title = getPageTitle(to.meta.title)

//     //  determine whether the user has logged in
//     const hasToken = true //  getToken()

//     if (hasToken) {
//       if (to.path === '/login') {
//         console.log('enter ok')
//         //  if is logged in, redirect to the home page
//         next({ path: '/' })
//         NProgress.done()
//       } else {
//         const hasGetUserInfo = store.getters.name
//         if (hasGetUserInfo) {
//           next()
//         } else {
//           try {
//             //  get user info
//             await store.dispatch('user/getInfo')

//             next()
//           } catch (error) {
//             //  remove token and go to login page to re-login
//             await store.dispatch('user/resetToken')
//             Message.error(error || 'Has Error')
//             next(`/login?redirect=${to.path}`)
//             NProgress.done()
//           }
//         }
//       }
//     }
//   else {
//     /* has no token*/

//     if (whiteList.indexOf(to.path) !== -1) {
//       //  in the free login whitelist, go directly
//       next()
//     } else {
//       //  other pages that do not have permission to access are redirected to the login page.
//       next(`/login?redirect=${to.path}`)
//       NProgress.done()
//     }
//   }
//   })

router.afterEach(() => {
  //  finish progress bar
  NProgress.done()
})
